export const parseRequestBody = (ctx) => {
    return new Promise((resolve, reject) => {
        let data = "";
        ctx.req.on("data", (chunk) => (data += chunk));
        ctx.req.on("end", () => {
            try {
                if (data === "") {
                    resolve({});
                }
                resolve(JSON.parse(data));
            } catch (err) {
                reject(err);
            }
        });
    });
};